angular.module('gym.contacts').factory('BluefinStoreService', ["$q", function($q) {
  var parseCardData;
  parseCardData = function(card) {
    var name;
    name = card.cardholder_name.split(' ');
    card.first_name = _.first(name);
    if (name.length > 1) {
      card.last_name = _.last(name);
    }
    card.card_expiration = card.card_expiration.replace(/\D+/g, '');
    card.card_number = card.card_number.replace(/\D+/g, '');
    return card;
  };
  return {
    store: function(bluefin_account, card, type) {
      var request_data, url;
      url = bluefin_account.payment_system_url;
      request_data = {
        account_id: bluefin_account.account_id,
        api_accesskey: bluefin_account.public_key,
        response_format: 'JSON',
        transaction_type: 'STORE',
        transaction_amount: '0.00',
        disable_redirect: 1
      };
      if (type === 'card') {
        request_data.tender_type = 'CARD';
        angular.extend(request_data, parseCardData(card));
      } else {
        request_data.tender_type = 'ACH';
        angular.extend(request_data, card);
      }
      return $.ajax({
        url: url,
        data: request_data,
        type: 'POST',
        dataType: 'json'
      });
    }
  };
}]);
